import React from 'react';
import PropTypes from 'prop-types';
import MappedAgentSelect from './MappedAgentSelect';
import { getUserIntegrationMap } from '../utils';
import { getUpdatedIntegrations } from './utils';

const UserIntegrations = ({
  integrationAgentsMap,
  leasingTeamIntegrations,
  mappedAgentOnChange,
  userIntegrations,
}) => {
  const userIntegrationMap = getUserIntegrationMap(userIntegrations);

  const handleMappedAgentOnChange =
    (mappedUserIntegration) => async (updatedMappedIntegration) => {
      const updatedIntegrations = getUpdatedIntegrations(
        userIntegrations,
        mappedUserIntegration,
        updatedMappedIntegration
      );

      return mappedAgentOnChange(updatedIntegrations);
    };

  return leasingTeamIntegrations.map((leasingTeamIntegration) => {
    const { property_id, vendor, vendor_property_id } = leasingTeamIntegration;
    const defaultUserIntegration = { property_id, vendor, vendor_property_id };

    const mappedUserIntegration =
      userIntegrationMap[vendor_property_id] || defaultUserIntegration;

    return (
      <td key={vendor_property_id}>
        <MappedAgentSelect
          agents={integrationAgentsMap[vendor_property_id]}
          key={mappedUserIntegration.mapped_agent_id}
          mappedAgentOnChange={handleMappedAgentOnChange(mappedUserIntegration)}
          mappedUserIntegration={mappedUserIntegration}
        />
      </td>
    );
  });
};

UserIntegrations.propTypes = {
  integrationAgentsMap: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })
    )
  ),
  leasingTeamIntegrations: PropTypes.arrayOf(
    PropTypes.shape({
      agents: PropTypes.arrayOf(
        PropTypes.shape({
          agent_id: PropTypes.number,
          agent_name: PropTypes.string,
          vendor_property_id: PropTypes.string,
        })
      ),
      property_id: PropTypes.number,
      property_name: PropTypes.string,
      vendor: PropTypes.string,
      vendor_property_id: PropTypes.string,
    })
  ),
  mappedAgentOnChange: PropTypes.func,
  userIntegrations: PropTypes.arrayOf(
    PropTypes.shape({
      mapped_agent_id: PropTypes.number,
      mapped_username: PropTypes.string,
      property_id: PropTypes.number,
      vendor: PropTypes.string,
      vendor_property_id: PropTypes.string,
    })
  ),
};

export default UserIntegrations;
